import { Injectable } from '@angular/core';
// License demo từ SDK mẫu TTXT (UAT domain). Khi có license chính thức từ TCDN thì thay ở đây.
const SDK_CONFIG: any = {
  detectionTimeoutMs: 90_000,
  fontFamily: "Times New Roman",
  fontSize: "28px",
  showLoading: true,
  overlayTransparent: true,
  palette: {
    primaryColor: "#4d4dff",
    secondaryColor: "#33cc33",
    textColor: "#ff4dc4",
    backgroundColor: "#c0bebe",
  },
  translations: {
    instruction: {
      move_closer: 'Di chuyển gương mặt lại gần camera',
      move_further: 'Di chuyển gương mặt ra xa camera',
      put_in_oval: 'Đưa khuôn mặt vào vùng oval',
      face_detected: 'Phát hiện khuôn mặt',
      watch_camera: 'Vui lòng nhìn thẳng vào camera',
      processing: 'Đang kiểm tra...',
      performing: 'Chúng tôi đang thực hiện...',
      uploading: 'Đang tải lên Facemap 3d mã hóa...',
      look_straight: 'Giữ mặt thẳng, không nghiêng.',
      action: 'Chúng tôi đang thực hiện...',
      put_face_in_oval: 'Đưa khuôn mặt vào khung hình',
      open_eyes: 'Giữ mặt bình thường, mở cả 2 mắt.',
    },
    loading: {
      message: 'Hệ thống đang được khởi tạo, vui lòng chờ trong giây lát...',
    },
    error: {
      verify_failed: 'Có vẻ như đã xảy ra lỗi, chúng tôi không thể quét gương mặt của bạn, Vui lòng thử lại',
      not_support_mobile: 'FaceAuthen SDK không hỗ trợ trên thiết bị di động',
    },
  },
};

/**
 * Service bao bọc SDK TTXT FaceAuthen (liveness detection).
 * SDK được đặt trong src/assets/libs/face-sdk và load động qua import() ở runtime.
 */
@Injectable({
  providedIn: 'root'
})
export class FaceSdkService {
  private faceSdk: any;
  async initialize(container: HTMLElement, SDK_LICENSE: string): Promise<void> {
    if (!this.faceSdk) {
      (globalThis as any).xqconfig = SDK_LICENSE;

      const sdkBase = new URL('/assets/libs/face-sdk/', document.baseURI).href;
      const boot: any = await import(/* webpackIgnore: true */ (sdkBase + 'boot.js'));
      await boot.load();
      const faceSdkImp: any = await import(/* webpackIgnore: true */ (sdkBase + 'index.js'));
      this.faceSdk = new faceSdkImp.FaceSDK(container, SDK_CONFIG);
    }
    await this.faceSdk.initialize();
  }

  async startDetection(nonce: string): Promise<any> {
    if (!this.faceSdk) throw new Error('SDK not initialized');
    return await this.faceSdk.startDetection(nonce);
  }

  destroy(): void {
    if (this.faceSdk) {
      // Nếu SDK không có hàm destroy, ta stop camera theo cách thủ công
      const videoEl = document.getElementById('inputVideo') as HTMLVideoElement;
      if (videoEl && videoEl.srcObject) {
        const stream = videoEl.srcObject as MediaStream;
        stream.getTracks().forEach(track => track.stop());
        videoEl.srcObject = null;
      }

      // Xóa SDK instance để lần sau initialize lại
      this.faceSdk = null;
    }
  }
}
